export const ReleaseInfo = Object.freeze({
  releaseVersion: "2026.7.17-1415.21",
  commitId: "b7196b2292eeadfeb3fc449858c0d929f717969d",
  commitTime: "2026-07-17T14:15:21.000Z",
});
